export function extractDriveId(input: string | undefined | null): string | null {
  if (!input) return null;

  if (!input.includes('/') && !input.includes('?')) return input.trim();

  const patterns = [
    /\/file\/d\/([^/]+)/,
    /\/d\/([^/]+)/,
    /[?&]id=([^&]+)/,
  ];

  for (const p of patterns) {
    const m = input.match(p);
    if (m?.[1]) return m[1];
  }

  return null;
}